<template>
  <product-variant-selection
    v-if="product"
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    as-form
    :attribute-selection-labels="attributeSelectionLabels"
    :error
    :get-attr-option-available="getAttrOptionAvailable"
    :get-attr-option-notify-me="getAttrOptionNotifyMe"
    :inventory
    :is-coming-soon="isComingSoon"
    :pending
    :product
    :reviews-data="reviewsData"
    :selected-variant="selectedVariant"
    :show-notify-me="$feature.showNotifyMeOnPDP"
    :show-single-attributes="$feature.showSingleAttributeOnPdp"
    @open-size-guide="openSizeGuide"
    @select-color="selectColor"
    @select-size="selectSize"
  />
</template>

<script setup lang="ts">
const {
  attributeSelection,
  attributeSelectionFormRef,
  attributeSelectionLabels,
  error,
  inventory,
  isComingSoon,
  getAttrOptionAvailable,
  getAttrOptionNotifyMe,
  openSizeGuide,
  pending,
  product,
  reviewsData,
  selectColor,
  selectSize,
  selectedVariant
} = usePdp()
</script>
